import { FirestoreDataConverter } from "firebase/firestore";
import moment from "moment";
import Pagamento from "../models/pagamento";
import PosicaoAtivo from "../models/posicaoAtivo";
import BaseDb from "./baseDb";

export default class PagamentoDb extends BaseDb<
  Pagamento,
  { usuarioId: string; pagamentoId: string }
> {
  _path: string = "usuarios/usuarioId/pagamentos/pagamentoId";
  getConverter(): FirestoreDataConverter<Pagamento> {
    return {
      fromFirestore: (snapshot, _options) =>
        new Pagamento({
          id: snapshot.id,
          codigoAtivo: snapshot.get("codigoAtivo"),
          dataCredito: moment(snapshot.get("dataCredito").toDate()),
          dataEx: moment(snapshot.get("dataEx").toDate()),
          tipo: snapshot.get("tipo"),
          valor: snapshot.get("valor"),
          pagamento: snapshot.get("pagamento"),
          acao: snapshot.get("acao"),
          dataEvento: moment(snapshot.get("dataEvento").toDate()),
          posicaoEx: new PosicaoAtivo({
            codigoAtivo: snapshot.get("posicaoEx.codigoAtivo"),
            classeAtivo: snapshot.get("posicaoEx.classeAtivo"),
            mercado: snapshot.get("posicaoEx.mercado"),
            precoMedio: snapshot.get("posicaoEx.precoMedio"),
            quantidade: snapshot.get("posicaoEx.quantidade"),
            tipoNegociacao: snapshot.get("posicaoEx.tipoNegociacao"),
            tipoOperacao: snapshot.get("posicaoEx.tipoOperacao"),
            valorTotal: snapshot.get("posicaoEx.valorTotal"),
            prazo: snapshot.get("posicaoEx.prazo"),
          }),
        }),

      toFirestore: (_pagamento: Pagamento) => {
        throw new Error("Não é possível criar um pagamentos");
      },
    };
  }
}
